import { layout } from 'thewest/App.routing'
import { metrics } from 'component-library/__styling/settings/metrics'
import { billboardLeaderboardMrec } from '../ad-units'

export function topicParallax(): typeof layout._componentType[] {
    return [
        {
            type: 'ad-unit',
            feature: ['running-parallax', true],
            props: {
                noticePosition: 'none',
                hiddenUntilLoaded: true,
                breakout: {
                    kind: 'percentage',
                    value: 5,
                    breakpoint: metrics.thewest.mainContentWidth,
                },
                padding: [0, 0, metrics.thewest.margins.lg, 0],
                slot: {
                    id: 'parallax',
                    size: 'parallax',
                },
            },
        },
        ...billboardLeaderboardMrec('parrallax'),
    ]
}
